<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    background-color: rgb(242,246,252);
    -webkit-overflow-scrolling: touch;
    #app {
      font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: left;
      color: #2c3e50;
      margin: 0;
      padding:  0;
      height: 100%;
      position: relative;
      font-size: 14px;
    }
    * {
      box-sizing: border-box;
    }
  }
  @media (max-width: 900px) {
    html, body {
      #app {
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue